import {Component, OnInit} from '@angular/core';
import {SpecialitesService} from '../../services/specialites/specialites.service';

@Component({
    selector: 'app-list-specialites',
    templateUrl: './list-specialites.component.html',
    styleUrls: ['./list-specialites.component.scss']
})
export class ListSpecialitesComponent implements OnInit {

    specialites: any;

    constructor(private specialitesService: SpecialitesService) {
    }

    ngOnInit(): void {
        const t = this;
        t.loadItems();
    }

    loadItems() {
        const t = this;
        this.specialitesService.get().subscribe((data: any) => {
            t.specialites = data;
            t.sortItems();
        });
    }

    sortItems() {
        const t = this;
        for (let i = 0; i < t.specialites.length; i++) {
            if ( t.specialites[i].active === false) {
                t.specialites.splice(i, 1);
                i--;
            }
        }
    }
}
